import { useParams } from 'react-router-dom';
import { tourismData } from '../../database/tourismData';

import { MdLocationOn } from 'react-icons/md';
import { FaRoute } from 'react-icons/fa';

import ReactMarkdown from 'react-markdown';

import styles from './TourismDatails.module.css';

export default function TourismDetails() {
  const { url } = useParams();
    
  const tourism = tourismData.find(e => e.url === url);

  if (!tourism) {
    return <div className={styles.notFound}>Ponto turístico não encontrado</div>;
  }

  const mapaSrc = tourism.enderecoMaps ? `https://www.google.com/maps?q=${encodeURIComponent(tourism.enderecoMaps)}&output=embed` : '';

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <div className={styles.history}>
          <div className={styles.containerHeader}>
             <h1 className={styles.title}>{tourism.nome}</h1>
          </div>
          <div className={styles.imageContainer}>
            <img src={tourism.imagem} alt={tourism.nome} />
            <div className={styles.imageOverlay}></div>
          </div>
          <div className={styles.contentBody}>
            <ReactMarkdown
              components={{
                img: ({ node, ...props }) => (
                  <img
                    {...props}
                    alt={props.alt || 'Imagem do conteúdo'}
                    className={styles.markdownImage}
                  />
                ),
              }}
            >
              {tourism.descricao}
            </ReactMarkdown>
          </div>
        </div>
        
        <aside className={styles.description}>
          <h2>Informações Úteis</h2>
          
          {tourism.endereco && (
            <div className={styles.serviceItem}>
              <div className={styles.iconWrapper}>
                <MdLocationOn size={24} />
              </div>
              <div className={styles.serviceContent}>
                <span className={styles.serviceLabel}>Endereço</span>
                <p>{tourism.endereco}</p>
              </div>
            </div>
          )}
          
          {tourism.maps && (
            <div className={styles.serviceItem}>
              <div className={styles.iconWrapper}>
                <FaRoute size={24} />
              </div>
              <div className={styles.serviceContent}>
                <span className={styles.serviceLabel}>Rota</span>
                <p><a href={tourism.maps} target='_blank' rel='noopener noreferrer'>Como chegar</a></p>
              </div>
            </div>
          )}
          
          {tourism.enderecoMaps && (
            <div className={styles.mapsContainer}>
              <iframe 
                src={mapaSrc}
                title={tourism.nome} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          )}
        </aside>
      </div>
    </main>
  );
}
